module.exports = __webpack_public_path__ + "static/img/template-img5.02285d09.png";